export default "__VITE_ASSET__06accbe2__"